<template>
  <div class="tableDiv">
    <el-table
      :data="list"
      border
      stripe
      fit
      :height="options.tableHeight"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <!-- 暂无数据提示，自己定义就OK了 -->
      <template slot="empty">
        <div class="no-data">
          <i class="crm-wu"></i>
          <span class="text-1">{{options.errortip}}</span>
        </div>
      </template>
      <!--region 选择框-->
      <el-table-column v-if="options.mutiSelect" type="selection" style="width: 55px;"></el-table-column>
      <!--endregion-->
      <!-- 编辑列start -->
      <template v-for="(column,$index) in columns">
        <template v-if="column.isfixed ||column.ismethod">
          <el-table-column
            :prop="column.prop"
            :key="$index"
            :fixed="column.fixed"
            :label="column.label"
            :align="column.align"
            :width="column.width"
            v-if="column.isShow"
          >
            <template slot-scope="scope">
              <el-button
                v-if="column.ismethod"
                type="text"
                class="link-type"
                @click="handleColumnChange(scope.$index,scope.row)"
              >{{list[scope.$index][column.prop]}}</el-button>
              <span v-else type="text">{{list[scope.$index][column.prop]}}</span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            :prop="column.prop"
            :key="$index"
            :label="column.label"
            :align="column.align"
            :width="column.width"
            v-if="column.isShow"
          >
            <!-- 判断是否有帮助-->
            <template slot-scope="scope">
              <el-tooltip
                v-if="list[scope.$index][column.prop]=='否'"
                class="item help-button"
                effect="dark"
                :content="reason[scope.$index]"
                placement="bottom-end"
              >
                <!-- {{list[scope.$index][column.invite_novisitreason]}} -->
                <el-button type="text">
                  {{list[scope.$index][column.prop]}}
                  <i class="el-icon-warning"></i>
                </el-button>
              </el-tooltip>
              <span
                v-else-if="list[scope.$index][column.prop]==null"
                type="text"
                class="none-type"
              >无</span>
              <span v-else-if="column.islevel">
                <i v-for="n in list[scope.$index][column.prop]" :key="n" class="icon-heart-off"></i>
              </span>
              <span v-else type="text">{{list[scope.$index][column.prop]}}</span>
            </template>
          </el-table-column>
        </template>
      </template>
      <!-- 编辑列end -->
      <!--region 按钮操作组-->
      <el-table-column
        ref="fixedColumn"
        :label="operates.label"
        :align="operates.align"
        :width="operates.width"
        :fixed="operates.fixed"
        v-if="operates.list.filter(_x=>_x.show === true).length > 0"
      >
        <template slot-scope="scope">
          <template v-for="(btn, key) in operates.list">
            <div class="item" v-if="btn.show" :key="btn.id">
              <el-button
                @click.native.prevent="btn.method(key,scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
              >{{ btn.label }}</el-button>
            </div>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-if="isPagination"
      style="margin-top: 35px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="400"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  name: "tipsTable",
  props: {
    list: {
      type: Array
      // default: []
    }, // 数据列表
    isCheckbox: null,
    isPagination: null,
    columns: {
      type: Array
      // default: []
    }, // 需要展示的列 === prop：列数据对应的属性，label：列名，align：对齐方式，width：列宽
    operates: {}, // 操作按钮组 === label: 文本，type :类型（primary / success / warning / danger / info / text），show：是否显示，icon：按钮图标，plain：是否朴素按钮，disabled：是否禁用，method：回调方法
    options: {
      type: Object
      // default: {
      //   highlightCurrentRow: false // 是否要高亮当前行
      // }
    } // table 表格的控制参数
  },
  data() {
    return {
      currentPage: 1,
      reason: []
    };
  },
  created() {
    (() => {})(this.node);
  },
  watch: {
    //列表信息监听
    getlist(n, o) {
      var len = n.length;
      var arr = [];
      if (len > 0) {
        n.forEach(element => {
          arr.push(element.invite_novisitreason);
        });
        this.reason = arr;
      }
      (() => {})(this.reason, 111111);
    }
  },
  computed: {
    getlist() {
      return this.list;
    }
  },
  methods: {
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      // (() => {})(val)
      this.$emit("handleSelectionChange", val);
    },
    handleColumnChange(k, v) {
      (() => {})(k, v);
      this.$emit("handleColumnChange", k, v);
    },
    handleCodeChange(k, v) {
      (() => {})(k, v);
      this.$emit("handleCodeChange", k, v);
    },
    // 分页
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
    }
  }
};
</script>
<style lang="less">
.item {
  display: inline-block;
}
.item + .item {
  margin-left: 15px !important;
}
.table-code {
  width: 40px;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
.none-type {
  color: #d9b409;
}
.sliderBox .el-tooltip__popper.is-dark {
  width: 155px;
  height: 63px;
  background: rgba(131, 191, 212, 0.5);
  // background: #83c7ef;
  border-radius: 8px;
  // opacity: 0.9645999999999999;
}
.help-button {
  .el-icon-warning {
    color: #20a8d8;
  }
  color: #333;
}

.sliderBox .el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: rgba(32, 168, 216, 0.5) !important;
}
.sliderBox .el-tooltip__popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: rgba(32, 168, 216, 0.5) !important;
}
.sliderBox .el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: rgba(32, 168, 216, 0.5) !important;
}
.sliderBox .el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: rgba(32, 168, 216, 0.5) !important;
}
</style>
